import { Box, Button, ButtonGroup, Divider } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { ManuallySelectedSchedules } from "./manually-selected-schedules"

export function ManuallyMapContent({ reset }) {
    const {
        manuallySelectedCount,
        manuallySelectedSchedulesCombined,
        removeManuallySelectedSchedule,
        chooseSchedules,
    } = useBoundContext()
    return (
        <Box pb={1} width={1}>
            <Divider sx={{ my: 1 }} />
            <If truthy={manuallySelectedCount}>
                <Box>
                    <Repeat
                        list={manuallySelectedSchedulesCombined}
                        item={<ManuallySelectedSchedules onRemove={removeManuallySelectedSchedule} />}
                    />
                </Box>
            </If>
            <ButtonGroup fullWidth size="small">
                <Button onClick={chooseSchedules} variant="outlined" data-cy="mapping-manual-select">
                    {manuallySelectedCount > 0 ? "Change Selection" : "Select Schedules"}
                </Button>
                {!!manuallySelectedCount && (
                    <Button
                        aria-label="Clear selected schedules"
                        onClick={reset}
                        sx={{ width: 40 }}
                        variant="contained"
                        data-cy="mapping-manual-clear"
                    >
                        <Iconify icon="ic:round-clear" />
                    </Button>
                )}
            </ButtonGroup>
        </Box>
    )
}
